import type * as Actions from './actions';
import { ActionTypes } from './actionTypes';

import type { DateRange, PageableContent, Sort } from '@cobliteam/common-types';

import type { UserAlert, UserAlertsFilters } from '@cobliteam/api-lib/';

export const loadUserAlertsRequest = (
  period: DateRange,
  page: number,
  size: number,
  filters?: UserAlertsFilters,
  sort?: Sort
): Actions.LoadAlertsRequest => ({
  type: ActionTypes.LOAD_ALERT_REQUEST,
  payload: { period, page, size, filters, sort },
});

export const loadUserAlertsSucceeded = (
  alertsPage: PageableContent<UserAlert>
): Actions.LoadAlertsSucceeded => ({
  type: ActionTypes.LOAD_ALERT_SUCCEEDED,
  payload: alertsPage,
});

export const loadUserAlertsFailed = (): Actions.LoadAlertsFailed => ({
  type: ActionTypes.LOAD_ALERT_FAILED,
});
